import type { Template } from "@/types";

export const LA_01_H1_V0: Template[] = [
{
    id: "la-01-h1v0-01",
    name: "LA 01 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 712, y: 69, width: 486, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v0-01",
    name: "LA 02 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 75, y: 69, width: 486, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h1v0-01",
    name: "LA 03 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 637, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v0-01",
    name: "LA 04 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h1v0-01",
    name: "LA 05 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 467, y: 39, width: 760, height: 400, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h1v0-01",
    name: "LA 06 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 46, y: 39, width: 760, height: 400, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v0-01",
    name: "LA 07 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 223, y: 43, width: 827, height: 388, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-08-h1v0-01",
    name: "LA 08 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 40, width: 1194, height: 394, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-09-h1v0-01",
    name: "LA 09 - H1V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 1274, height: 476, rotation: 0, imageRotation: 0 }
    ],
}
];